export class GroupLandingInstallment {
    count?: number;
    price?: number;

    static fromJson(fields: any): GroupLandingInstallment {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
